import { render, staticRenderFns } from "./ChatbotAdmin.vue?vue&type=template&id=378c6f64&scoped=true"
import script from "./ChatbotAdmin.vue?vue&type=script&lang=js"
export * from "./ChatbotAdmin.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=378c6f64&prod&scoped=true&lang=css&external"
import style1 from "./ChatbotAdmin.vue?vue&type=style&index=1&id=378c6f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c6f64",
  null
  
)

export default component.exports